export function isDevModEnabled(): boolean {
  const search = typeof window !== "undefined" ? window.location.search : "";
  return new URLSearchParams(search).get("idm") === "true";
}
